import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import styles from "./BaseModal.module.scss";
import { SDialog } from "@avalara/skylab-sdk/react";

export interface BaseModalProps {
  className?: string;
  isOpen: boolean;
  onRequestClose?: () => void;
}

function BaseModal({
  className,
  isOpen,
  onRequestClose,
  children,
}: PropsWithChildren<BaseModalProps>) {
  return (
    <>
      <SDialog
        open={isOpen}
        className={classNames(className, styles.container)}
        onS-dismiss={onRequestClose}
      >
        <div slot="body" className={classNames("modal-body")}>
          {children}
        </div>
      </SDialog>
      {isOpen && <div className={styles.backdrop}></div>}
    </>
  );
}

export default BaseModal;
